// Shared web constants.
export { APP_STORE_WEB_URL as APP_STORE_URL } from "../../../constants/appStore";

export const UNIVERSITY = "University of Miami";
